var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Wrapper',{ref:"wrapper",attrs:{"type-list":"friends","item-source":_vm.fetchFriends,"popover-position-target":_vm.popoverPositionTarget,"popover-items":_vm.items,"dummy-props":{
    headerText: _vm.$t(
      '_web_account-list_dummy_friends',
      'You have no friends at the moment'
    ),
    text: _vm.$t(
      '_web_account-list_dummy_friends_subheader',
      'Your current and future friends are waiting for you. Do not hesitate to find them'
    ),
  }},on:{"hidePopover":function($event){_vm.popoverPositionTarget = null}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var user = ref.user;
return (!user.isHidden)?_c('ListItemAccount',_vm._b({key:user.login,staticClass:"mb-3 py-2 pl-5 pr-5"},'ListItemAccount',{
      type: user.type,
      avatar: user.avatar,
      name: _vm.$filters.displayName(user),
      accountId: user.login,
      approved: user.approved,
      vanityId: user.vanityId || user.vanity_id,
    },false),[(_vm.account._canEdit && _vm.myAccountId !== user.login)?_c('div',{staticClass:"d-flex align-items-center",attrs:{"slot":"action"},slot:"action"},[(_vm.myAccountId !== user.login)?_c('FollowBtn',{staticClass:"h-mr-3",attrs:{"model":_vm.createAccountModel(user),"follow-class":""},on:{"toggleFollow":function (isFollow) { return _vm.toggleFollow(isFollow, user); }}}):_vm._e(),_c('AppIcon',{staticClass:"cursor-pointer px-3 py-4",attrs:{"name":"dots","fill":_vm.$scss.heraMuted,"hover-fill":_vm.$scss.hoverColor},on:{"click":function($event){$event.stopPropagation();return (function (event) { return _vm.dotsClickHandler(event, user); })($event)}}})],1):_vm._e()]):_vm._e()}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }